import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  listUserRoles,
  getNotificationSettings,
  submitNotificationSettings,
} from './peopleService';

// Fetch notification settings from given user
export const fetchNotificationSettings = createAsyncThunk('people/notificationSettings', async (employeeId) => {
  const settings = await getNotificationSettings(employeeId);
  return settings;
});

// Save all notifications settings from given user
export const saveNotificationSettings = createAsyncThunk('people/notificationSettingsSync', async ({ eid, payload }) => {
  await submitNotificationSettings(eid, payload);
});

// Read all set claims from a given user
export const getEmployeeClaims = createAsyncThunk('people/listUserRoles', async ({ userId, venueId }) => {
  if (userId)  {
    // Backend would complain but it's expected to have employees without uid,
    // which means they have not logged in into their venues yet...
    return listUserRoles(userId, venueId);
  }
  return {};
});
